import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "config/routes";
import IPrivateRouteProps from "pages/PageRoot/types";
import { useAppSelector } from "store/hooks/useAppSelector";

const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  const isLoggedIn = useAppSelector((state) => state.auth.login);

  return isLoggedIn ? children : <Navigate to={routes.signin.root} replace />;
};

export default PrivateRoute;
